export default __webpack_public_path__ + "static/media/vic-1.e3cab966.webp";